<template>
  <div class="my-article">
    <div class="filter-bar" v-if="isSelf">
      <div class="filter-item" :class="{ active: audit_state == 0 }" @click="handleStateFilter(0)">全部</div>
      <div class="filter-item" :class="{ active: audit_state == -1 }" @click="handleStateFilter(-1)">违规帖</div>
    </div>
    <div class="article-list">
      <scroll-comp ref="scrollComp" :page-load="getList">
        <template>
          <user-article-list-item
            v-for="item in list"
            :key="item.id"
            :item="item"
            show-game
            :show-user="false"
            layout="column"
          />
        </template>
      </scroll-comp>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiUserContentList } from "@/api/userApi";
import ScrollComp from "@/components/Scroll";
import UserArticleListItem from "./components/userArticleListItem";

export default {
  name: "index",
  mixins: [],
  props: {},
  model: {},
  components: {
    UserArticleListItem,
    ScrollComp
  },
  data() {
    return {
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      audit_state: 0,
      list: []
    };
  },
  computed: {
    ...mapGetters(["loginUser"]),
    isSelf() {
      return this.loginUser && this.loginUser.uid == this.$route.params.id;
    }
  },
  methods: {
    pageLoad() {
      this.getList();
    },
    handleStateFilter(type) {
      this.audit_state = type;
      this.list = [];
      this.pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      this.$refs.scrollComp.loadStatus = "loading";
      this.getList();
    },
    getList() {
      let { pagination, $refs, $route } = this;

      if ($refs.scrollComp.loadStatus == "end") return;
      ++pagination.page_no;
      let params = {
        ...pagination,
        uid: $route.params.id,
        audit_state: this.audit_state
      };
      $refs.scrollComp.loadStatus = "loading";
      apiUserContentList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          // 达到最大页数后，不触发翻页方法；
          if (this.pagination.page_no >= this.pagination.page_total) {
            $refs.scrollComp.loadStatus = "end";
          } else {
            $refs.scrollComp.loadStatus = "";
          }
        });
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    console.log(this.loginUser)
    this.getList();
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.filter-bar {
  display: flex;
  align-items: center;
  gap: 32px;
  width: 100%;
  height: 44px;
  padding: 0 28px;
  border-bottom: 1px solid #eeeff4;
  .filter-item {
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      font-weight: bold;
      color: #151515;
    }
    &.active {
      font-weight: bold;
      color: #151515;
    }
  }
}
</style>
